import styles from './chat.module.css'
import { useEffect, useState } from 'react'

import { swalErrorAlert, swalToast } from '../../utils/swal/swal'
import { getChatUserListApi, getRoomIdApi } from '../../api/chat'
import { MdRefresh } from 'react-icons/md'

export default function ChatUserList({ setRoomId, myInfo, setOtherInfo, isAdmin = false }) {
  const [userList, setUserList] = useState([]) // 사용자리스트
  const [search, setSearch] = useState('') // 검색창
  const [selectedUserId, setSelectedUserId] = useState('') // 선택된 사용자

  useEffect(() => {
    getUserList()
  }, [])

  useEffect(() => {
    getRoomId()
  }, [selectedUserId])

  const getRoomId = async () => {
    const user1Id = myInfo?.user_id
    const user2Id = selectedUserId
    if (!user1Id || !user2Id) return

    try {
      const response = await getRoomIdApi(user1Id, user2Id)
      if (response.data?.code === 200) {
        const roomId = response.data?.resData
        setRoomId(roomId)
      } else {
        setRoomId('')
      }
      return
    } catch (error) {
      console.log(error)
      swalErrorAlert('채팅방 조회 에러', '채팅방 데이터를 불러오는 도중에 에러가 발생하였습니다.')
      return
    }
  }

  const getUserList = async () => {
    if (!myInfo?.user_id) return

    try {
      const response = await getChatUserListApi(myInfo.user_id, isAdmin)
      if (response.data.code === 200) {
        const userList = response.data.resData
        setUserList(userList)
        return
      } else {
        throw new Error('사용자 목록 조회 결과 없음')
      }
    } catch (error) {
      console.log(error)
      swalErrorAlert('사용자 목록 조회 결과 에러', '사용자 목록을 조회하는 도중에 에러가 발생하였습니다')
      return
    }
  }

  const onClickRefresh = async () => {
    await getUserList()
    await swalToast.fire({
      icon: 'success',
      title: '목록을 새로고침 했습니다.',
    })
  }

  const filteredUsers = userList
    ? [...userList]
      .filter((user) => user.user_id != myInfo.user_id)
      .filter((user) => user.user_name.toLowerCase().includes(search.toLowerCase()))
    : []

  const unreadUsers = userList ?
    userList.filter(user => user.unread_count > 0)
    : []


  return (
    <div className={styles.userList}>
      <h3 className='d-flex justify-content-between'>
        {isAdmin ? '사용자 목록' : '선생님 목록'}

        {/* 새로고침 */}
        <span className={styles.refreshBtn} onClick={onClickRefresh}><MdRefresh /></span>
      </h3>
      <input
        type="text"
        className={styles.searchInput}
        placeholder="이름 검색"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <ul style={{ maxHeight: "380px" }}>
        {filteredUsers.map((user) => (
          <li
            key={user.user_id}
            className={`${user.user_id === selectedUserId ? styles.active : ''}`}
            onClick={() => {
              setSelectedUserId(user.user_id)
              setOtherInfo({ user_id: user.user_id, user_name: user.user_name })
            }}>
            {user.user_name}
            {user.unread_count > 0 && <span className={styles.unreadCnt}>{user.unread_count}</span>}
          </li>
        ))}
      </ul>

      {unreadUsers.length > 0 &&
        (
          <>
            <hr />
            <h3>읽지 않은 메세지</h3>
            <ul style={{ maxHeight: "280px" }}>
              {unreadUsers.map(user => {
                return (
                  <li
                    key={user.user_id}
                    className={`${user.user_id === selectedUserId ? styles.active : ''}`}
                    onClick={() => {
                      setSelectedUserId(user.user_id)
                      setOtherInfo({ user_id: user.user_id, user_name: user.user_name })
                    }}>
                    {user.user_name}
                    {user.unread_count > 0 && <span className={styles.unreadCnt}>{user.unread_count}</span>}
                  </li>
                )
              })}
            </ul>
          </>
        )}


    </div>
  )
}
